import { render, staticRenderFns } from "./ModalValidaNaoLidos.vue?vue&type=template&id=2ebbc729&scoped=true"
import script from "./ModalValidaNaoLidos.vue?vue&type=script&lang=js"
export * from "./ModalValidaNaoLidos.vue?vue&type=script&lang=js"
import style0 from "./ModalValidaNaoLidos.vue?vue&type=style&index=0&id=2ebbc729&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebbc729",
  null
  
)

export default component.exports